export class UserModel{
    Name : any;
    Mobile : any;
    Email : any;
    DivisionId: { name: string; id: number[] }[] = [];
    DistrictId: { name: string; id: number[] }[] = [];
    ProvinceId:  { name: string; id: number[] }[] = [];
    //DistrictId : number;
    //DivisionId:number;
    IsActive:any;
}
export class UserViewModel{
    Name : any;
    Mobile : any;
    Email : any;
    DistrictId : number;
    DivisionId:number;
    ProvinceId:number;
    IsActive:any;
    User:
        {
            UserName:any;
            Password:any;
        }
    
}
export class editUser{
    Name : any;
    Mobile : any;
    Email : any;
    DistrictId : any;
    DivisionId:any;
    ProvinceId:any;
    IsActive:any
}
export class filt{
    Name : any;
    Mobile : any;
    Email : any;
    DistrictId : any;
    DivisionId:any;
    ProvinceId:any;
}